import { EExerciseType, TExerciseItem } from "types/app/exercises";

export const buttonExercise: TExerciseItem = {
  title: "Кнопка",
  backgroundText: "Кнопка",
  tags: ["кнопка", "button"],
  type: EExerciseType.BUTTON,
  cover: "button.png",
};
